
import React from "react";

const Nav = () =>{
    return(
        <div>


        <nav className="navbar navbar-expand-lg  fixed-top p-0">
          <div className="container-fluid mx-5">
            <a className="navbar-brand fs-2 text-light" href="#">Foo<span>diii</span></a>
            <button className="navbar-toggler text-white" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon text-white"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a href="/Home" className="nav-link active px-4 text-light" aria-current="page" >Home</a>
                </li>
                <li className="nav-item">
                  <a href="/Product" className="nav-link px-4 text-light" aria-current="page">Product</a>
                </li>
                <li className="nav-item">
                  <a href="/About" className="nav-link px-4 text-light" aria-current="page">About Us </a>
                </li>
                <li className="nav-item">
                  <a href="/Services" className="nav-link px-4 text-light" aria-current="page">Services</a>
                </li>
                <li className="nav-item">
                  <a href="/Contact" className="nav-link px-4 text-light" aria-current="page">Contact Us</a>
                </li>
               
              </ul>
            
            </div>
          </div>
        </nav>
                
                </div>
    )
}


export default Nav;